export default __webpack_public_path__ + "static/media/XTZ-BNB.f7bc389a.svg";